import { useEffect, useState } from "react";
import { useErrorsContext } from "components/lookup-tables/contexts/ErrorsContext";
import { useFetchErrors } from "components/lookup-tables/hooks/useLookupTablesAPI";
const ErrorsConsumer = ({
  lutNames = void 0,
  cacheNames = void 0,
  adapterNames = void 0
}) => {
  const [fetchInterval, setFetchInterval] = useState();
  const { setErrors } = useErrorsContext();
  const { fetchErrors } = useFetchErrors();
  useEffect(() => {
    if (fetchInterval) clearInterval(fetchInterval);
    setFetchInterval(
      setInterval(() => {
        fetchErrors({ lutNames, cacheNames, adapterNames }).then(
          ({ tables, caches, data_adapters }) => setErrors({ lutErrors: tables, cacheErrors: caches, adapterErrors: data_adapters })
        );
      }, 1e3)
    );
    return () => clearInterval(fetchInterval);
  }, [lutNames, cacheNames, adapterNames]);
  return null;
};
export default ErrorsConsumer;
